import React from 'react';
import '../css/form.css';
import axios from 'axios';
import { Form, Button, Container, Modal, Spinner, Col, Row, Table } from 'react-bootstrap';
import EncabezadoCliente from '../components/header';
import { validate, format } from '@validatecl/rut';
import Planes from '../components/getPlanes';
import Profesion from '../components/get_profesion';
import Nacionalidad from '../components/nacionalidad';
// import Region from '../components/region';
// import Ciudad from '../components/ciudad';
import Comuna from '../components/comuna';
import MostrarDetalle from '../components/mostrardetalle';
import Banco from '../components/banco';


let baseUrl = 'https://b316wmuwh1.execute-api.us-east-1.amazonaws.com/default/res_json_formulario';
axios.defaults.headers.post['authorizationToken'] = '&S396b<eg5Zn(HiLe)BBNtc&';

class Venta extends React.Component {

    constructor(props) {
        //obtengo los parametros de la url para luego utilizarlos        
        const { match: { params } } = props;
        //console.log(params)

        super(props);
        this.state = {
            id_gestion: params.idGestion,
            id_contacto: params.idContacto,
            id_campana: params.idCampana,
            id_contacto_genesys: params.idContactoGenesys,
            id_ejecutivo: params.idEjecutivo,
            fono: params.fono,
            cola: params.cola,
            formValid: false,
            confirm: false,
            Rut: '',
            contador: 0,
            data: null,
            datadesc: null,
            dataid: null,
            UltimosCuatroDigitos:'',
        };

        //Se definen las funciones llamadas por el formulario
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.dataValidation = this.dataValidation.bind(this);
        this.handleMostrarModal = this.handleMostrarModal.bind(this);
        this.handleEnviodatos = this.handleEnviodatos.bind(this);
        this.validaRut = this.validaRut.bind(this);
        this.handleInputPlan = this.handleInputPlan.bind(this);
        this.mostrarBeneficiario = this.mostrarBeneficiario.bind(this);
        this.ocultarModal = this.ocultarModal.bind(this);
        this.handleChangeComuna = this.handleChangeComuna.bind(this);
        this.handleInputChangeBanco = this.handleInputChangeBanco.bind(this);
        this.handleInputChangeFecha = this.handleInputChangeFecha.bind(this);

    }

    //con este metodo se guarda el dato de ingresado con la variable ingresada en los props
    async handleInputChange(event) {
        const target = event.target;
        const valor = target.value;
        const nombre = target.name;
        this.setState({
            [nombre]: valor
        })
    }

    handlePadre = (nrohijo) => {
        console.log('envio de nrohijo' + nrohijo)
        var suma = this.state.contador + nrohijo
        this.setState({ contador: suma })
    }

    mostrarAseg() {
        this.setState({
            showAdi: true,
            contador: this.state.contador + 1
        })
    }
    mostrarBenef() {
        this.setState({
            showBenef: true,
            contador: this.state.contador + 1
        })
    }

    //seleccion para region ciuda y comuna ademas del resetearSelect() cuando se cambia algun componente anterior
    resetearSelect() {
        this.setState({
            Region: '',
            RegionId: '',
            ComunaId: '',
            Comuna: '',
            Ciudad: '',
            CiudadId: '',
        })
    }

    handleChangeComuna(event) {
        if (event.target.value === '') {
            this.resetearSelect()
        } else {
            console.log(event.target.value)
            this.setState({
                Comuna: event.target.value,
                ComunaId: event.target.value.split('-')[0],
                ComunaDesc: event.target.value.split('-')[1],
            });
        }
    }
    //fin region,ciudad,comuna

    //Con el siguiente metodo se guarda el plan con sus respectivos valores
    async handleInputPlan(event) {
        const target = event.target;
        const valor = target.value;
        const nombre = target.name;
        this.setState({
            [nombre]: valor,
            pro_cod_plan: valor.split('|')[1],
            pro_valu_plan: valor.split('|')[3],
            pro_desc_plan: valor.split('|')[2]
        })
    }

    //metodo para validar el rut
    validaRut(rut) {
        console.log('validando rut...')
        const isValid = validate(rut);

        console.log(isValid)
        if (isValid === false) {
            alert('rut no valido, por favor escribir nuevamente');
            document.getElementById('btn_form').hidden = false;
            document.getElementById('cargando').hidden = true;
            return false
        } else {
            return true
        }

    }

    //metodo para la accion de la presion del btn submit 
    async handleSubmit(e) {
        e.preventDefault();
        if (this.dataValidation === false) {
            this.setState({ formValid: false })
            return (alert('Ingresa campos requeridos!'))
        } else {
            console.log('obtengo metodo de los datos')
            this.handleMostrarModal()
        }
    }

    //abre el modal para confirmar el envio de datos
    async handleMostrarModal() {
        console.log('confirma los datos')
        this.setState({ show: true })
    }

    //confirma el envio de datos para continuar con el envio de datos
    async handleConfirm() {
        this.setState({ show: false, confirm: true })
        document.getElementById('btn_form').hidden = true;
        document.getElementById('cargando').hidden = false;
        this.handleEnviodatos()//metodo de envio de datos

    }

    //cierra el modal para confirmar los datos
    async handleClose() {
        this.setState({
            show: false,
        })
    }

    //valida que los datos que esten en el formulario sean correctos en este caso que no se encuentren vacios
    async dataValidation() {
        console.log('Validando Datos')
        if (this.state.dataCiu !== '' && this.state.data !== '') {
            return true
        } else {

            return false
        }
    }

    handleInputChangeNacionalidad = (event) => {
        if (event.target.value !== '') {
            this.setState({
                Nacionalidad: event.target.value,
                NacionalidadId: event.target.value.split('|')[1],
                NacionalidadDesc: event.target.value.split('|')[2],
            })
        }
    }

    handleInputChangeProfesion = (event) => {
        if (event.target.value !== '') {
            // console.log(event.target.value)
            this.setState({
                Profesion: event.target.value,
                ProfesionId: event.target.value.split('|')[0],
                ProfesionDesc: event.target.value.split('|')[1],
            })
        }
    }
    handleInputChangeBanco = (event) => {
        if (event.target.value !== '') {
            // console.log(event.target.value)
            this.setState({
                Banco: event.target.value,
                BancoId: event.target.value.split('|')[0],
                BancoDesc: event.target.value.split('|')[1],
            })
        }
    }

    handleInputChangeFecha = (event) => {
        if (event.target.value !== '') {
            // console.log(event.target.value)
            this.setState({
                fechaven: event.target.value,
                anio: event.target.value.split('-')[0],
                mes: event.target.value.split('-')[1],
                fechavenreal: event.target.value.split('-')[1] + '-' + event.target.value.split('-')[0]
            })
        }
    }

    mostrarBeneficiario() {
        this.setState({
            showBenef: true,
        })
    }

    ocultarModal() {
        this.setState({
            showBenef: false,
        })
    }

    //metodo para el envio de datos que posee el formulario a la base de datos
    async handleEnviodatos() {
        //en esta serccion se ingresan los datos a enviar por el formulario
        const body = JSON.stringify({
            id_gestion: this.state.id_gestion,
            id_contacto: this.state.id_contacto,
            id_campana: this.state.id_campana,
            id_contacto_genesys: this.state.id_contacto_genesys,
            id_ejecutivo: this.state.id_ejecutivo,
            fono: this.state.fono,
            cola: this.state.cola,
            Plan: this.state.Plan,
            pro_cod_plan: this.state.pro_cod_plan,
            pro_desc_plan: this.state.pro_desc_plan,
            pro_valu_plan: this.state.pro_valu_plan,
            TipoTarjeta: this.state.TipoTarjeta,
            Fechavencimiento: this.state.fechavenreal,
            Banco: this.state.Banco,
            BancoId: this.state.BancoId,
            BancoDesc: this.state.BancoDesc,
            CodigoProd: this.state.MedioPago,
            Rut: format(this.state.Rut, false),
            FechaNacimiento: this.state.Fechanacimiento,
            Nombre: this.state.Nombre,
            SegundoNombre: this.state.SegundoNombre,
            ApPaterno: this.state.ApPaterno,
            ApMaterno: this.state.ApMaterno,
            Region: this.state.Region,
            RegionDesc: this.state.RegionDesc,
            RegionId: this.state.RegionId,
            Ciudad: this.state.Ciudad,
            CiudadDesc: this.state.CiudadDesc,
            CiudadId: this.state.CiudadId,
            Comuna: this.state.Comuna,
            ComunaDesc: this.state.ComunaDesc,
            ComunaId: this.state.ComunaId,
            TipoCalle: this.state.TipoCalle,
            Direccion: this.state.Direccion,
            TipoVivienda: this.state.TipoVivienda,
            Numeracion: this.state.Numeracion,
            Telefono: this.state.Telefono,
            Mail: this.state.Mail,
            Profesion: this.state.Profesion,
            Nacionalidad: this.state.Nacionalidad,
            NacionalidadId: this.state.NacionalidadId,
            NacionalidadDesc: this.state.NacionalidadDesc,
            Beneficiario: this.state.Beneficiario,
            Observacion: this.state.Observacion,
            UltimosCuatroDigitos: this.state.UltimosCuatroDigitos,
            Sexo: this.state.Sexo,
        })
        console.log(body)
        var contadorsuma = this.state.contador + 1;
        //con este metodo le pegamos un post a lambda para el envio de datos
        if (this.validaRut(this.state.Rut) === true) {
            await axios.post(baseUrl, body)
                .then(response => {
                    if (response.status === 200) {
                        document.getElementById('btn_form').hidden = false;
                        document.getElementById('cargando').hidden = true;
                        document.getElementById('btn_form').disabled = true;
                        document.getElementById('ok').hidden = false;
                        this.setState({ contador: contadorsuma })
                    }
                    else {
                        document.getElementById('error').hidden = true;
                    }
                    console.log('el metodo responde: ' + response.data.state);
                    console.log('Envio a parent');
                    //this.limpiarForm(); metodo para limpiar Formulario esto se debe crear
                    window.parent.postMessage({ gestion_finished: true }, "*")
                })
                .catch(response => {
                    console.log(response + ' error POST envio datos')
                })
        }
    }

    render() {
        var { contador } = this.state
        var currentTime = new Date()
        var month1 = currentTime.getMonth() + 1
        var day1 = currentTime.getDate()
        var year1 = currentTime.getFullYear()
        if (month1 < 10) month1 = "0" + month1;
        if (day1 < 10) day1 = "0" + day1;
        const curdate = year1 + "-" + month1 + "-" + day1
        const curdate2 = year1 + "-" + month1
        return (
            <Container>
                <div>
                    <EncabezadoCliente data={this.state.id_contacto}></EncabezadoCliente>
                </div>
                <hr />
                <div className="row align-items-end ">
                    <div className="col align-self-center h-h-100 p-5 bg-light border rounded-3">
                        <Form onSubmit={this.handleSubmit}>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Plan</Form.Label>
                                    <Form.Control name='Plan' size='sm' as="select" value={this.state.Plan} onChange={this.handleInputPlan} required>
                                        <option value="">Seleccionar Plan</option>
                                        <Planes></Planes>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Tipo de tarjeta</Form.Label>
                                    <Form.Control name='TipoTarjeta' size='sm' as="select" value={this.state.TipoTarjeta} onChange={this.handleInputChange}>
                                        <option value="">Seleccionar Tipo de tarjeta</option>
                                        <option value="11">MAGNA</option>
                                        <option value="3">DINERS</option>
                                        <option value="4">VISA</option>
                                        <option value="5">MC</option>
                                        <option value="6">AMERICAN EXPRESS</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Fecha de vencimiento</Form.Label>
                                    <Form.Control size='sm' type="month" min={curdate2} name='Fechavencimiento' value={this.state.Fechavencimiento} onChange={this.handleInputChangeFecha} />
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Institucion de Pago</Form.Label>
                                    <Form.Control name='Banco' size='sm' as="select" value={this.state.Banco} onChange={this.handleInputChangeBanco} >
                                        <option value="">Seleccionar Tipo de Banco</option>
                                        <Banco></Banco>
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Ultimos cuatro digitos tarjeta</Form.Label>
                                    <Form.Control name='UltimosCuatroDigitos' type='number' min='0' max='9999' size='sm' value={this.state.UltimosCuatroDigitos} onChange={this.handleInputChange} />
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Medio de Pago</Form.Label>
                                    <Form.Control name='MedioPago' size='sm' as="select" value={this.state.MedioPago} onChange={this.handleInputChange} required>
                                        <option value="">Seleccionar Medio de Pago</option>
                                        <option value="8660">Cuenta Vista</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Fecha de nacimiento</Form.Label>
                                    <Form.Control size='sm' type='date' max={curdate} min="1900-01-01" name='Fechanacimiento' value={this.state.Fechanacimiento} onChange={this.handleInputChange} required />
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Rut Contratante</Form.Label>
                                    <Form.Control name='Rut' size='sm' value={this.state.Rut} onChange={this.handleInputChange} required />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control name='Nombre' size='sm' value={this.state.Nombre} onChange={this.handleInputChange} required />
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Segundo Nombre</Form.Label>
                                    <Form.Control name='SegundoNombre' size='sm' value={this.state.SegundoNombre} onChange={this.handleInputChange} required />
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Apellido Paterno</Form.Label>
                                    <Form.Control name='ApPaterno' size='sm' value={this.state.ApPaterno} onChange={this.handleInputChange} required />
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Apellido Materno</Form.Label>
                                    <Form.Control name='ApMaterno' size='sm' value={this.state.ApMaterno} onChange={this.handleInputChange} required />
                                </Form.Group>
                            </Row><Row className="mb-3">
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Sexo</Form.Label>
                                    <Form.Control name='Sexo' size='sm' as="select" value={this.state.Sexo} onChange={this.handleInputChange} required>
                                        <option value="">Seleccionar Sexo</option>
                                        <option value="M">Masculino</option>
                                        <option value="F">Femenino</option>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Comuna</Form.Label>
                                    <Form.Control name='Comuna' size='sm' as="select" value={this.state.Comuna} onChange={this.handleChangeComuna} required>
                                        <option value="">Seleccionar Comuna</option>
                                        <Comuna></Comuna>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Tipo Calle</Form.Label>
                                    <Form.Control name='TipoCalle' size='sm' as="select" value={this.state.TipoCalle} onChange={this.handleInputChange} required>
                                        <option value=''>Tipo Calle</option>
                                        <option value='Avenida'>Avenida</option>
                                        <option value='Pasaje'>Pasaje</option>
                                        <option value='Calle'>Calle</option>
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Direccion</Form.Label>
                                    <Form.Control name='Direccion' size='sm' value={this.state.Direccion} onChange={this.handleInputChange} required />
                                </Form.Group>
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Tipo de vivienda</Form.Label>
                                    <Form.Control name='TipoVivienda' placeholder="depto,casa,villa,parcela,etc" size='sm' value={this.state.TipoVivienda} onChange={this.handleInputChange} required />
                                </Form.Group>
                                <Form.Group as={Col} md="4" className="mb-4">
                                    <Form.Label>Numeracion</Form.Label>
                                    <Form.Control name='Numeracion' size='sm' type='number' min='0' value={this.state.Numeracion} onChange={this.handleInputChange} required />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Telefono</Form.Label>
                                    <Form.Control name='Telefono' size='sm' value={this.state.Telefono} onChange={this.handleInputChange} required />
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Mail</Form.Label>
                                    <Form.Control name='Mail' size='sm' value={this.state.Mail} onChange={this.handleInputChange} required />
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-1">
                                    <Form.Label>Profesion</Form.Label>
                                    <Form.Control name='Profesion' size='sm' as="select" value={this.state.Profesion} onChange={this.handleInputChangeProfesion} required>
                                        <option value="">Seleccionar Profesion</option>
                                        <Profesion></Profesion>
                                    </Form.Control>
                                </Form.Group>
                                <Form.Group as={Col} md="3" className="mb-1">
                                    <Form.Label>Nacionalidad</Form.Label>
                                    <Form.Control name='Nacionalidad' size='sm' as="select" value={this.state.Nacionalidad} onChange={this.handleInputChangeNacionalidad} required>
                                        <option value="">Seleccionar Nacionalidad</option>
                                        <Nacionalidad></Nacionalidad>
                                    </Form.Control>
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Form.Label>Beneficiarios</Form.Label>
                                    <Form.Check type='radio' name='TipoBeneficiario' label='Herederos Legales' onChange={this.handleInputChangeSelect}
                                        value='Heredero Legal' required />
                                    <Form.Check type='radio' name='TipoBeneficiario' label='Ingresar Beneficiarios' onChange={this.handleInputChangeSelect}
                                        value='Beneficiario Adicional' required />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="12" className="mb-12">
                                    <Form.Label>Observacion</Form.Label>
                                    <Form.Control name='Observacion' as='textarea' size='sm' value={this.state.Observacion} onChange={this.handleInputChange} />
                                </Form.Group>
                            </Row>
                            <Row className="mb-3">
                                <Form.Group as={Col} md="3" className="mb-3">
                                    <Button variant="primary" type="submit" id='btn_form'>Finalizar</Button>
                                </Form.Group>
                                <Spinner animation="border" id='cargando' variant="primary" hidden />
                            </Row>
                        </Form>
                        <div className="success-msg" id='ok' hidden><i className="fa fa-check"></i> Venta exitosa.</div>
                        <div className="error-msg" id='error' hidden><i className="fa fa-times-circle"></i> Error al ingresar la Venta.</div>
                    </div>
                </div>
                <br />
                <div>
                    <Table responsive striped bordered hover>
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Ver informacion</th>
                                <th>Ingresar Adicional</th>
                                {/* <th>Ingresar Beneficiario</th> */}
                                <th>Rut</th>
                                <th>Nombre Completo</th>
                                <th>Fecha Nacimiento</th>
                                <th>Prima</th>
                                <th>Plan</th>
                            </tr>
                        </thead>
                        <MostrarDetalle data={this.state.id_contacto} contador={contador}
                            id_contacto={this.state.id_contacto}
                            id_campana={this.state.id_campana}
                            id_contacto_genesys={this.state.id_contacto_genesys}
                            fono={this.state.fono}
                            cola={this.state.cola}
                            id_ejecutivo={this.state.id_ejecutivo}></MostrarDetalle>
                    </Table>
                </div>
                <Modal
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        {/* <Modal.Title>Modal title</Modal.Title> */}
                    </Modal.Header>
                    <Modal.Body>
                        Desea guardar los cambios del formulario?
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="danger" onClick={this.handleClose}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={this.handleConfirm}>Confirmar</Button>
                    </Modal.Footer>
                </Modal>
                <hr />
            </Container>
        )
    }

}

export default Venta